import { render } from "./pickUpEdit.vue?vue&type=template&id=247237d0&scoped=true"
import script from "./pickUpEdit.vue?vue&type=script&lang=js"
export * from "./pickUpEdit.vue?vue&type=script&lang=js"

import "./pickUpEdit.vue?vue&type=style&index=0&id=247237d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247237d0"]])

export default __exports__